import { createSlice } from '@reduxjs/toolkit';
import { dispatch } from '../../store';
import { get, post, put } from '../../../inteceptor';
import moment from 'moment';

const initialState = {
  error: null,
  time: null,
  data: [],
  allData: [],
  addData: {},
  sorted: [],
};

const slice = createSlice({
  name: 'Guests',
  initialState,
  reducers: {
    // HAS ERROR
    hasError(state, action) {
      state.error = { message: action.payload, time: moment.now().toString() };
    },

    getGuestSuccess(state, action) {
      state.data = action.payload.data;
    },
    getAllGuestSuccess(state, action) {
      state.allData = action.payload.data;
    },
    getGuestFromBardSuccess(state, action) {
      state.pos = action.payload.data;
    },

    addOrUpdateGuest(state, action) {
      state.addData = {
        data: action.payload.data,
        time: moment.now().toString(),
      };
    },

    clearAll(state) {
      state.addData = {};
      state.error = {};
    },

    onBackStep(state) {
      state.checkout.activeStep -= 1;
    },

    onNextStep(state) {
      state.checkout.activeStep += 1;
    },

    onGotoStep(state, action) {
      state.checkout.activeStep = action.payload;
    },
  },
});

// Reducer
export default slice.reducer;

// Actions
export const { filterCategories } = slice.actions;

// ----------------------------------------------------------------------

export function getAllGuest() {
  return async () => {
    try {
      const response = await get(`Guest`);
      if (response.status) {
        dispatch(slice.actions.getAllGuestSuccess(response));
      } else {
        dispatch(slice.actions.hasError(response.message));
      }
    } catch (error) {
      console.log(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function getGuestFromBard(cardId) {
  return async () => {
    try {
      const response = await get(`getGuestFromBard/${cardId}`);
      if (response.status) {
        dispatch(slice.actions.getGuestFromBardSuccess(response));
      } else {
        dispatch(slice.actions.hasError(response.message));
      }
    } catch (error) {
      console.log(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getGuest(isDeleted) {
  return async () => {
    try {
      const response = await get(`Guest?isDeleted=${isDeleted}`);
      if (response.status) {
        dispatch(slice.actions.getGuestSuccess(response));
      } else {
        dispatch(slice.actions.hasError(response.message));
      }
    } catch (error) {
      console.log(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getGuestsForRevenueReport() {
  return async () => {
    try {
      const response = await get(`getGuestsForRevenueReport`);
      if (response.status) {
        dispatch(slice.actions.getGuestSuccess(response));
      } else {
        dispatch(slice.actions.hasError(response.message));
      }
    } catch (error) {
      console.log(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function addGuest(body) {
  return async () => {
    try {
      const response = await post(`Guest`, body);
      if (response.status) {
        dispatch(slice.actions.addOrUpdateGuest(response));
      } else {
        dispatch(slice.actions.hasError(response.message));
      }
    } catch (error) {
      console.log(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function updateGuest(body) {
  return async () => {
    try {
      const response = await put(`Guest/${body?.id}`, body);
      if (response.status) {
        dispatch(slice.actions.addOrUpdateGuest(response));
      } else {
        dispatch(slice.actions.hasError(response.message));
      }
    } catch (error) {
      console.log(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}
